import { Component, Inject, input, OnInit, output } from '@angular/core';

interface ModalStatusData {
  title?: string;
  subtitle?: string;
  text?: string;
}

@Component({
  selector: 'app-modal-status',
  templateUrl: './modal-status.component.html',
  styleUrls: ['./modal-status.component.scss'],
})
export class ModalStatusComponent {
  readonly data = input<ModalStatusData>();
  readonly closed = output<boolean>();

  onSubmit() {
    this.closed.emit(true);
  }

  onClose(submit?: boolean): void {
    this.closed.emit(Boolean(submit));
  }
}
